<template>
  <div class="main">
    <Loading v-if="loading" />
    <div class="header">
      <PageHeader />
    </div>
    <div class="sectionOne">
      <div>
        <h3>Pay Bills</h3>
        <vue-typed-js :strings="['Seamlessly']" :backDelay="3000" :loop="true">
          <h3><span class="typing"></span></h3>
        </vue-typed-js>
        <p class="norma">
          Teller helps you to pay your electricity, cable, internet and other
          bills with ease.
        </p>
        <div class="my-2">
          <v-btn @click="navigate('signup')" class="createAccBtn" dark>
            <span> Create Free Account</span>
          </v-btn>
        </div>
        <div class="downloadapp">
          <div @click="navigateToStore()" class="appstore">
            <img
              src="../assets/google.png"
              alt="google logo"
              width="133"
              height="40"
            />
          </div>

          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on" class="appstore">
                <img
                  src="../assets/apple.png"
                  alt="apple logo"
                  width="133"
                  height="40"
                />
              </div>
            </template>
            <span>Not Available</span>
          </v-tooltip>
        </div>
      </div>
    </div>
    <div class="sectionTwo">
      <img
        src="../assets/Rectangle.png"
        alt="teller logo"
        width="100%"
        height="100%"
      />
    </div>
    <div class="sectionThree">
      <div data-aos="fade-up" class="sectionThreeDiv">
        <div class="sectionThreeDivIm">
          <img
            src="../assets/wallet.png"
            alt="apple logo"
            width="170"
            height="140"
          />
        </div>
        <div class="sectionThreeDivIm">
          <h4 class="robust">
            Robust consumer services platform
          </h4>
          <p class="robustTxt norma">
            For convenient airtime recharge, funds transfer, bills payments.
            Making your everyday payment simple, safe and secure.
          </p>
        </div>
      </div>
    </div>
    <div class="sectionFour">
      <div data-aos="fade-left" class="sectionFourDiv">
        <div class="sectionFourDivChild">
          <img
            src="../assets/walletIcon.png"
            alt="teller logo"
            width="47"
            height="40"
          />
          <h5 class="Send-Recieve-Money">
            Send & Recieve Money
          </h5>
          <p class="color-white">
            <small>
              Send and receive money seamlessly with the Teller App to any bank
              in Nigeria
            </small>
          </p>
        </div>
        <div class="sectionFourDivChild">
          <img
            src="../assets/BillsIcon.png"
            alt="teller logo"
            width="47"
            height="40"
          />
          <h5 class="Send-Recieve-Money">
            Bills Payments
          </h5>
          <p class="color-white">
            <small>
              Pay your Electricity, Cable, Internet and other bills with ease by
              just a click of few buttons
            </small>
          </p>
        </div>
        <div class="sectionFourDivChild">
          <img
            src="../assets/AirtimeIcon.png"
            alt="teller logo"
            width="47"
            height="40"
          />
          <h5 class="Send-Recieve-Money">
            Airtime Purchase
          </h5>
          <p class="color-white">
            <small>
              Buy airtime from any network in seconds with the Teller App.
            </small>
          </p>
        </div>
        <div class="sectionFourDivChild">
          <img
            src="../assets/PosIcon.png"
            alt="teller logo"
            width="47"
            height="40"
          />
          <h5 class="Send-Recieve-Money">
            POS Services
          </h5>
          <p class="color-white">
            <small>
              Be an Agency banking agent with our POS devices- Banking on the
              go. Easy, safe and affordable.
            </small>
          </p>
        </div>
      </div>
    </div>
    <div class="sectionFive">
      <img
        data-aos="fade-right"
        class="imgtag"
        src="../assets/phone.png"
        alt="apple logo"
        width="390"
        height="580"
      />
    </div>
    <div class="sectionSix">
      <div class="sectionSixDiv" data-aos="fade-down">
        <h3>
          Join thousands of Teller users today.
        </h3>
        <p class="norma">
          Teller provides online payment settlement system which allows instant
          money transfer, bill payment, and
          <br />
          airtime purchases. It’s safe, reliable and most importantly,
          hassle-free.
        </p>
        <div class="my-2">
          <v-btn @click="navigate('signup')" class="createAccBtnTwo" dark
            >Create Free Account</v-btn
          >
        </div>
        <div class="downloadapp">
          <div @click="navigateToStore()" class="appstore">
            <img
              src="../assets/google.png"
              alt="google logo"
              width="133"
              height="40"
            />
          </div>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on" class="appstore">
                <img
                  src="../assets/apple.png"
                  alt="apple logo"
                  width="133"
                  height="40"
                />
              </div>
            </template>
            <span>Not Available</span>
          </v-tooltip>
        </div>
      </div>
    </div>
    <footer class="sectionFooterone">
      <div class="sectionFooteroneDiv">
        <img
          src="../assets/logo2.png"
          alt="teller logo"
          width="160"
          height="40"
        />
        <p />
        <br />
        <p class="color-white foote">
          Teller is a financial service application that enables you make online
          transactions like, Sending and receiving money, buy airtime, pay bills
          etc.
        </p>
        <br />
        <p class="color-white foote">
          Office: Suite 13, Eastley Park Plaza, 5 Barthurst Street, Off Aminu
          Kano Cresent Wuse 2, Abuja.
        </p>
        <p class="color-white foote">
          +234 8188964415, +234 8169602155 (Mon-Fri from 8am-5pm) -
          help@teller.ng
        </p>
        <br />
        <p class="color-white foote">
          &#169; 2020 Teller Agency Services Ltd
        </p>
      </div>
    </footer>
    <footer class="sectionFootertwo">
      <div class="sectionFooteroneDivTwo">
        <h5 class="color-white ml-5">
          <b>
            Connect with us on social
          </b>
        </h5>
        <v-btn
          @click="navigateSocal(icon.link)"
          v-for="icon in icons"
          :key="icon"
          class="color-white ml-5 mt-5"
          icon
        >
          <v-icon color="white" size="39px">{{ icon.icon }}</v-icon>
        </v-btn>
      </div>
    </footer>
  </div>
</template>

<script>
import PageHeader from "../components/Header";
import AOS from "aos";
import "aos/dist/aos.css";

export default {
  metaInfo: {
    title: "Teller",
    meta: [
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      {
        name: "Teller.ng",
        content:
          "Teller.ng provides online payment settlement system which allows instant money transfer, bill payment, and airtime purchases. It’s safe, reliable and most importantly, hassle-free.Teller helps you to pay your electricity, cable, internet and other bills with ease.  For convenient airtime recharge, funds transfer, bills payments. Making your everyday payment simple, safe and secure.",
      },
    ],
  },
  created() {
    AOS.init({
      once: true,
      offset: 300, // offset (in px) from the original trigger point
      delay: 100, // values from 0 to 3000, with step 50ms
      duration: 1000, // values from 0 to 3000, with step 50ms
    });
  },
  computed: {
    isIdle() {
      return this.$store.state.idleVue.isIdle;
    },
    loading() {
      return this.$store.state.User.loading;
    },
    snackbar() {
      return this.$store.state.User.snackbar;
    },
  },
  components: {
    PageHeader,
  },

  data: () => ({
    drawer: false,
    group: null,
    icons: [
      { icon: "mdi-facebook", link: "https://www.instagram.com/teller.ng/" },
      { icon: "mdi-twitter", link: "https://www.instagram.com/teller.ng/" },
      { icon: "mdi-instagram", link: "https://www.instagram.com/teller.ng/" },
    ],
  }),
  watch: {
    group() {
      this.drawer = false;
    },
  },
  methods: {
    navigate(to) {
      this.$router.push({ name: to });
    },
    navigateToStore() {
      let url =
        "https://play.google.com/store/apps/details?id=com.teller.android";
      window.open(url, "_blank");
    },
    navigateSocal(payload) {
      let url = payload;
      window.open(url, "_blank");
    },
  },
};
</script>

<style scoped>
@font-face {
  font-family: "AvenirLTProBlack";
  src: url("~@/assets/font/FontsFree-Net-SFProDisplay-Regular.ttf");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "FontsFree-Net-SFProDisplay-Regular.";
  src: url("~@/assets/font/FontsFree-Net-SFProDisplay-Regular.ttf");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "SF-UI-Display-Bold";
  src: url("~@/assets/font/SF-UI-Display-Bold.otf");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "AvenirLTProBook";
  src: url("~@/assets/font/AvenirLTProBook.otf");
  font-weight: normal;
  font-style: normal;
}

.main {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-auto-rows: minmax(100px, auto);
  margin: 0 auto;
  padding: 0px;
  grid-template-areas:
    "header header header header"
    "sectionOne sectionOne sectionTwo sectionTwo"
    "sectionOne sectionOne sectionTwo sectionTwo"
    "sectionOne sectionOne sectionTwo sectionTwo"
    "sectionThree sectionThree sectionThree sectionThree"
    "sectionFour sectionFour sectionFive sectionFive"
    "sectionFour sectionFour sectionFive sectionFive"
    "sectionFour sectionFour sectionFive sectionFive"
    "sectionFour sectionFour sectionFive sectionFive"
    "sectionFour sectionFour sectionFive sectionFive"
    "sectionFour sectionFour sectionFive sectionFive"
    "sectionFour sectionFour sectionFive sectionFive"
    "sectionSix sectionSix sectionSix sectionSix"
    "sectionSix sectionSix sectionSix sectionSix"
    "sectionSix sectionSix sectionSix sectionSix"
    "sectionFooterone sectionFooterone sectionFootertwo sectionFootertwo"
    "sectionFooterone sectionFooterone sectionFootertwo sectionFootertwo"
    "sectionFooterone sectionFooterone sectionFootertwo sectionFootertwo";
}
.main::-webkit-scrollbar {
  display: none !important;
}
.main {
  -ms-overflow-style: none !important; /* IE and Edge */
  scrollbar-width: none !important; /* Firefox */
}
.header {
  grid-area: header;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.menuBtn {
  display: none;
}

.sectionOne {
  grid-area: sectionOne;
  align-self: center;
  padding-right: 90px !important;
  padding-left: 90px !important;
}
.sectionTwo {
  grid-area: sectionTwo;
}
.sectionThree {
  grid-area: sectionThree;
}
.sectionFour {
  grid-area: sectionFour;
  background-color: #ac158c;
}
.sectionFive {
  grid-area: sectionFive;
  background-color: red;
}
.sectionSix {
  grid-area: sectionSix;
}
.sectionFooterone {
  grid-area: sectionFooterone;
  background-color: #452065;
}
.sectionFootertwo {
  grid-area: sectionFootertwo;
  background-color: #452065;
  border-top-right-radius: 60px;
}
.sectionFooteroneDiv {
  padding-top: 50px;
  padding-left: 50px;
}
.sectionFooteroneDivTwo {
  padding-top: 70px;

  margin-left: 100px;
}
.loginBtn {
  width: 183px;
  height: 46px;
  border-radius: 15px;
  border: solid 1px #452065;
}
.loginText {
  height: 16px;
  font-family: SFProDisplay;
  font-size: 13px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: normal;
  color: #452065;
  text-transform: none;
}
.sectionOne h3 {
  font-family: SFUIDisplay;
  font-size: 56px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.21;
  letter-spacing: normal;
  color: #452065;
}
.sectionOne p {
  font-family: SFProDisplay;
  font-size: 19px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.89;
  letter-spacing: normal;
  color: #183b56;
}
.createAccBtn {
  width: 279px;
  height: 55px !important;
  margin-top: 20px;
  border-radius: 15px;
  background-color: #ac158c !important;
}
.downloadapp {
  width: 279px;
  display: flex;
  margin-top: 32px;
  justify-content: space-between;
}
.sectionThreeDiv {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 144px;
  background-color: rgba(187, 107, 217, 0.05);
}
.sectionThreeDivIm {
  margin: 10px;
}
.robust {
  font-family: SFProDisplay;
  font-size: 36px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.44;
  letter-spacing: normal;
  color: #16133e;
}
.robustTxt {
  font-family: SFProDisplay;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.79;
  letter-spacing: normal;
  color: #16133e;
}

.sectionFour {
  margin-top: 200px;
  border-top-left-radius: 90px;
  border-bottom-left-radius: 90px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.sectionFourDiv {
  display: flex;
  flex-flow: wrap;
  padding-left: 50px;
  padding-top: 50px;
  padding-bottom: 50px;
}
.sectionFourDivChild {
  width: 250px;
  margin: 20px;
}
.sectionFive {
  margin-top: 200px;
  position: relative;
  background-color: #ac158c;
}
.imgtag {
  position: absolute;
  top: -100px;
  right: 35%;
}
.color-white {
  color: white !important;
}
.color-black {
  color: black !important;
}
.Send-Recieve-Money {
  font-family: SFProDisplay;
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.17;
  letter-spacing: normal;
  color: #ffffff;
}
.sectionSixDiv {
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 70px;
  text-align: center;
}
.sectionSixDiv h3 {
  font-family: SFProDisplay;
  font-size: 26px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.44;
  letter-spacing: normal;
  color: #16133e;
  margin: 20px;
}

.sectionSixDiv p {
  font-family: SFProDisplay;
  font-size: 19px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.89;
  letter-spacing: normal;
  color: #16133e;
}
.createAccBtnTwo {
  width: 279px;
  height: 55px !important;
  margin-top: 20px;
  border-radius: 15px;
  background-color: #9f09d7 !important;
}
.appstore img {
  cursor: pointer !important;
}

.norma {
  font-family: "AvenirLTProBlack" !important;
}
h3 {
  font-family: " SF-UI-Display-Bold" !important;
}
h4 {
  font-family: " FontsFree-Net-SFProDisplay-Regular" !important;
}
h5 {
  font-family: "SF-UI-Display-Bold" !important;
}
.foote {
  font-family: "AvenirLTProBook" !important;
  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #ffffff;
}

@media only screen and (max-width: 700px) {
  .main {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-auto-rows: minmax(100px, auto);
    margin: 0 auto;
    padding: 0px;
    grid-template-areas:
      "header header header header"
      "sectionOne sectionOne sectionOne sectionOne"
      "sectionTwo sectionTwo sectionTwo sectionTwo"
      "sectionThree sectionThree sectionThree sectionThree"
      "sectionFour sectionFour sectionFour sectionFour"
      "sectionFive sectionFive sectionFive sectionFive"
      "sectionFive sectionFive sectionFive sectionFive"
      "sectionFive sectionFive sectionFive sectionFive"
      "sectionFive sectionFive sectionFive sectionFive"
      "sectionFive sectionFive sectionFive sectionFive"
      "sectionSix sectionSix sectionSix sectionSix"
      "sectionFooterone sectionFooterone sectionFooterone sectionFooterone"
      "sectionFootertwo sectionFootertwo sectionFootertwo sectionFootertwo";
  }
  .header {
    grid-area: header;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-right: 20px !important;
    padding-left: 20px !important;
  }
  .sectionOne {
    grid-area: sectionOne;
    align-self: center;
    padding-right: 20px !important;
    padding-left: 20px !important;
    margin-top: 40px;
  }
  .sectionOne h3 {
    font-size: 36px;
    color: #452065;
  }
  .loginBtn {
    display: none;
  }
  .menuBtn {
    display: inline;
  }
  .createAccBtn {
    width: 179px;
    height: 55px !important;
    margin-top: 20px;
    border-radius: 15px;
    background-color: #ac158c !important;
  }
  .createAccBtn span {
    font-size: 10px;
  }
  .robust {
    font-size: 16px;
    text-align: center;
  }
  .robustTxt {
    font-size: 13px;
    text-align: center;
  }
  .sectionThreeDiv {
    padding-top: 100px;
    padding-bottom: 100px;
    padding-left: 20px;
    padding-right: 20px;
  }
  .sectionThreeDiv img {
    height: 130px;
    width: 100px;
  }
  .sectionFour {
    margin-top: 10px;
    border-bottom-left-radius: 0px;
  }
  .sectionFive {
    margin-top: 0px;
  }
  .imgtag {
    position: absolute;
    top: 0px;
    right: -1%;
  }
  .sectionFooterone {
    border-top-right-radius: 60px;
    padding-right: 20px;
  }
  .sectionFootertwo {
    grid-area: sectionFootertwo;
    background-color: #452065;
    border-top-right-radius: 0px;
  }
}
</style>
